import { createContext, useContext, useEffect, useState, useCallback } from "react";

const STEPS = ["100%", "112.5%", "125%", "137.5%"]; // Small · Default · Large · X-Large
const DEFAULT_STEP = 1;

const DisplayContext = createContext(null);

function applyTheme(dark) {
  const el = document.documentElement;
  if (dark) el.classList.add("dark");
  else el.classList.remove("dark");
}
function applyFont(step) {
  document.documentElement.style.fontSize = STEPS[step] || STEPS[DEFAULT_STEP];
}

export function DisplayProvider({ children }) {
  const [dark, setDark] = useState(() => localStorage.getItem("ap_theme") === "dark");
  const [fontStep, setFontStep] = useState(() => {
    const s = parseInt(localStorage.getItem("ap_fontstep") ?? "", 10);
    return Number.isInteger(s) && s >= 0 && s < STEPS.length ? s : DEFAULT_STEP;
  });

  useEffect(() => { applyTheme(dark); localStorage.setItem("ap_theme", dark ? "dark" : "light"); }, [dark]);
  useEffect(() => { applyFont(fontStep); localStorage.setItem("ap_fontstep", String(fontStep)); }, [fontStep]);

  const toggleDark = useCallback(() => setDark((d) => !d), []);
  const incFont = useCallback(() => setFontStep((s) => Math.min(STEPS.length - 1, s + 1)), []);
  const decFont = useCallback(() => setFontStep((s) => Math.max(0, s - 1)), []);

  return (
    <DisplayContext.Provider value={{ dark, toggleDark, fontStep, incFont, decFont, maxStep: STEPS.length - 1 }}>
      {children}
    </DisplayContext.Provider>
  );
}

export function useDisplay() {
  const ctx = useContext(DisplayContext);
  if (!ctx) throw new Error("useDisplay must be used within DisplayProvider");
  return ctx;
}
